import { PropsWithChildren, useState } from "react";
import {
    useFloating,
    useInteractions,
    useRole,
    autoUpdate,
    offset,
    flip,
    shift,
    useClientPoint
} from "@floating-ui/react";
import { FloatingMouseContentWrapper } from "./FloatingMouseTooltip.styles";
import { V3TTContentWrapper } from "../Tooltip/V3Tooltip.styles";

interface FloatingMouseTooltipProps extends PropsWithChildren {
    text?: string,
}

export const FloatingMouseTooltip = ({ children, text = "Preview of your portfolio" }: FloatingMouseTooltipProps) => {

    const [isOpen, setIsOpen] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        strategy: "fixed",
        placement: "bottom",
        onOpenChange: setIsOpen,
        // placement,
        // Make sure the tooltip stays on the screen
        whileElementsMounted: autoUpdate,
        middleware: [
            // Make sure tooltip is X pixels away from reference element
            offset(20),
            // Make sure the tooltip is in view, even if it can't be fully centered to the element
            shift({ padding: 5 }),
            // Make sure the placement is respected as long as there is space
            flip({ fallbackAxisSideDirection: "start" }),
        ]
    });

    const clientPoint = useClientPoint(context, {
        enabled: isOpen
    });

    const role = useRole(context, { role: "tooltip" }); // Role props for screen readers

    const { getReferenceProps, getFloatingProps } = useInteractions([
        role,
        clientPoint
    ]);

    return <>
        <FloatingMouseContentWrapper
            ref={refs.setReference}
            {...getReferenceProps()}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            {children}
        </FloatingMouseContentWrapper>
        {
            isOpen && <V3TTContentWrapper
                ref={refs.setFloating}
                style={floatingStyles}
                {...getFloatingProps()}
                $hideOnMobile={false}
            >{text}</V3TTContentWrapper>
        }
    </>
}